import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV, BRAND } from "@/data/site";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === "/";
  const solid = scrolled || !isHome;

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        solid ? "bg-[#0B0B0B]/95 backdrop-blur-md border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-32 md:h-40 flex items-center justify-between gap-4">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-3 group shrink-0">
          <img
            src={BRAND.logo}
            alt="AF Legacy Sports"
            className="h-24 md:h-32 w-auto object-contain transition-transform duration-500 group-hover:scale-[1.03]"
          />
        </Link>

        <nav className="hidden xl:flex items-center gap-5 2xl:gap-7">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.to.replace(/\//g, "") || "home"}`}
              className={({ isActive }) =>
                `text-[0.68rem] 2xl:text-[0.72rem] uppercase tracking-[0.18em] 2xl:tracking-[0.22em] font-medium whitespace-nowrap transition-colors ${
                  isActive ? "text-[#A67C00]" : "text-white hover:text-[#A67C00]"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden xl:flex items-center gap-4">
          <Link
            to="/submeter-perfil"
            data-testid="header-submit-cta"
            className="btn-gold"
          >
            Submeter perfil
          </Link>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="xl:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div
          data-testid="mobile-menu"
          className="xl:hidden bg-[#0B0B0B] border-t border-white/5"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`mobile-nav-${n.to.replace(/\//g, "") || "home"}`}
                className="text-white uppercase text-sm tracking-[0.2em] hover:text-[#A67C00]"
              >
                {n.label}
              </Link>
            ))}
            <Link
              to="/submeter-perfil"
              data-testid="mobile-submit-cta"
              className="btn-gold justify-center mt-2"
            >
              Submeter perfil
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
